import {
    AssginPersonal,
    QueryDevelopBudget,
    QueryForecastNot,
    QueryPersonal,
    QueryPersonal2,
    QuerySettlementPage,
    QueryEditStockTarget,
    QueryTarget,
    SaveStockTarget,
    UpdateSettlementForecast,
    editForecast,
    getBudgetDetail,
    getIncomeTargetTree,
    getIncomeTargetTreeByCurrentUserRecursive,
    queryForecast,
    queryForecastDetail,
    queryForecastEdit,
    queryIncomeBudget,
    queryIncomeDetailByType,
    queryIncomeReality,
    queryIncomeRealityType,
    queryIncomeTotal,
    saveIncomeCurrentBatch,
    saveIncomeTargetBatch,
    saveRemark,
    submitBudget,
    QueryViewTarget,
    QueryCompanyMarkTarget,
    SaveCompanyMarkTarget,
    SaveTotalMarkTarget,
    SaveAdjustRule,
    SubmitPrepare,
    SubmitersonPrepare,
    SubmitPersonPrepare,
    SubmitManagePrepare,
    QueryManageTarget,
    SaveManageTarget,
    SaveMarkTarget,
    QueryBaseCustomer,
    ViewItemsByCustomerId,
    SaveItemsTarget,
    AdjustItemsRule,
    QueryUpUser,
    QueryItemsByUserCustomerId,
    QuerySettlementUser,
    QueryItemsSettlement,
    QueryCustomerSettlement,
    QueryCustomerFinance,
    QueryItemsFinance,
    QueryViewItemsForecast,
    SubmitForecastNew,
    QueryForecastByMonth,
    QueryMedicalItems,
    QueryTrackCustomer,
    QueryTrackMedical,
    QueryMedicalDocts,
    QueryTrend,
    QuerySettleByDoctor,
    QueryUpData,
    SaveUpForecast,
    MarkNoAssginForecast,
    QueryNoAssginForecast,
    QueryIncomeActualFinish,
    QueryIncomeActualFinishArea,
    QueryIncomeActualFinishUser,
    QueryIncomeActualFinishCustomer,
    QueryOffsetUserData,
    QueryOffsetCustomerData,
    QueryIncomeAreaCompare,
    QueryIncomeUserCompare,
    QueryIncomeCustomerCompare
} from '@/request/income';
import { renderQuotaChildren } from '@/utils/common';
import { QueryOffsetAreaData } from '../../request/income';
export default {
    namespace: true,
    state: {
        incomeTree: [],
        currentIncomeTree: [],
        incomeBudget: {},
        incomeReality: {},
        incomeRealityType: {},
        incomeRealityTotal: {},
        forecastList: {},
        forecastMarkList: {},
        forecastNot: {},
        medicalItems: [],
        settlementPage: {},
        settleDoctor: {}
    },
    mutations: {
        SET_INCOME_TREE(state, incomeTree) {
            state.incomeTree = incomeTree;
        },

        SET_CURRENT_INCOME_TREE(state, currentIncomeTree) {
            state.currentIncomeTree = currentIncomeTree;
        },

        SET_INCOME_BUDGET(state, incomeBudget) {
            state.incomeBudget = incomeBudget;
        },

        SET_INCOME_REALITY(state, incomeReality) {
            state.incomeReality = incomeReality;
        },

        SET_INCOME_REALITY_TYPE(state, incomeRealityType) {
            state.incomeRealityType = incomeRealityType;
        },

        SET_INCOME_REALITY_TOTAL(state, incomeRealityTotal) {
            state.incomeRealityTotal = incomeRealityTotal;
        },

        SET_FORECAST_LIST(state, forecastList) {
            state.forecastList = forecastList;
        },

        SET_FORECAST_NOT(state, forecastNot) {
            state.forecastNot = forecastNot;
        },

        SET_FORECAST_MARK_LIST(state, forecastMarkList) {
            state.forecastMarkList = forecastMarkList;
        },

        SET_SETTLEMENT_PAGE(state, settlementPage) {
            state.settlementPage = settlementPage;
        },

        SET_MEDICAL_ITEMS(state, medicalItems) {
            state.medicalItems = medicalItems;
        },

        SET_SETTLEMENT_DOCTOR(state, settleDoctor) {
            state.settleDoctor = settleDoctor;
        }
    },
    actions: {
        UPDATE_INCOME: async ({ commit }, payload) => {
            commit('SET_INCOME_TREE', payload);
        },
        UPDATE_CURRENT_INCOME: async ({ commit }, payload) => {
            commit('SET_CURRENT_INCOME_TREE', payload);
        },
        QUERY_INCOME_TREE: async ({ commit }, payload) => {
            let res = await getIncomeTargetTree(payload);
            if (res?.code == 200) {
                let list = renderQuotaChildren(res.data);
                commit('SET_INCOME_TREE', list);
            }
            return res;
        },

        QUERY_CURRENT_INCOMR_TREE: async ({ commit }, payload) => {
            let res = await getIncomeTargetTreeByCurrentUserRecursive(payload);
            if (res?.code == 200) {
                let list = renderQuotaChildren(res.data);
                commit('SET_CURRENT_INCOME_TREE', list);
            }
            return res;
        },

        SAVE_ASSGIN_QUOTA: async ({}, payload) => {
            let res = await saveIncomeTargetBatch(payload);
            return res;
        },

        SAVE_CURRENT_BATCH: async ({}, payload) => {
            let res = await saveIncomeCurrentBatch(payload);
            return res;
        },

        QUERY_INCOME_BUDGET: async ({ commit }, payload) => {
            let res = await queryIncomeBudget(payload);
            if (res?.code == 200) {
                let data = res.data.data?.map(item => {
                    return {
                        ...item,
                        comeType: item.customerName + '-' + item.incomeTypeCode
                    };
                });
                commit('SET_INCOME_BUDGET', { ...res.data, data });
            }
            return res;
        },

        GET_BUDGET_DETAIL: async ({}, payload) => {
            let res = await getBudgetDetail(payload);
            return res;
        },

        SAVE_REMARK: async ({}, payload) => {
            let res = await saveRemark(payload);
            return res;
        },

        SUBMIT_BUDGET: async ({}, payload) => {
            let res = await submitBudget(payload);
            return res;
        },

        QUERY_INCOME_REALITY: async ({ commit }, payload) => {
            let res = await queryIncomeReality(payload);
            if (res?.code == 200) {
                commit('SET_INCOME_REALITY', res.data ?? {});
            }
            return res;
        },

        QUERY_INCOME_REALITY_TYPE: async ({ commit }, payload) => {
            let res = await queryIncomeRealityType(payload);
            if (res?.code == 200) {
                commit('SET_INCOME_REALITY_TYPE', res.data ?? {});
            }
            return res;
        },

        QUERY_INCOME_REALITY_TOTAL: async ({ commit }, payload) => {
            let res = await queryIncomeTotal(payload);
            if (res?.code == 200) {
                commit('SET_INCOME_REALITY_TOTAL', res.data ?? {});
            }
            return res;
        },

        QUERY_INCOME_DETAIL_BY_TYPE: async ({}, payload) => {
            let res = await queryIncomeDetailByType(payload);
            return res;
        },

        // 收入预测
        QUERY_FORECAST_LIST: async ({ commit }, payload) => {
            let res = await queryForecast(payload);
            if (res?.code == 200) {
                commit('SET_FORECAST_LIST', res.data ?? {});
            }
            return res;
        },

        QUERY_FORECAST_NOT: async ({ commit }, payload) => {
            let res = await QueryForecastNot(payload);
            if (res?.code == 200) {
                commit('SET_FORECAST_NOT', res.data ?? {});
            }
            return res;
        },

        // 收入预测
        QUERY_FORECAST_MARK_LIST: async ({ commit }, payload) => {
            let res = await queryForecastEdit(payload);
            if (res?.code == 200) {
                commit('SET_FORECAST_MARK_LIST', res.data ?? {});
            }
            return res;
        },

        QUERY_FORECAST_DETAIL: async ({}, payload) => {
            let res = await queryForecastDetail(payload);
            return res;
        },

        EDIT_FORECAST: async ({}, payload) => {
            let res = await editForecast(payload);
            return res;
        },

        // 结算
        QUERY_SETTLEMENT_PAGE: async ({ commit }, payload) => {
            let res = await QuerySettlementPage(payload);
            if (res?.code == 200) {
                commit('SET_SETTLEMENT_PAGE', res.data ?? {});
            }
            return res;
        },

        // 开发客户预估
        QUERY_DEVELOP_BUDGET: async ({ commit }, payload) => {
            let res = await QueryDevelopBudget(payload);
            return res;
        },

        QUERY_TARGET: async ({ commit }, payload) => {
            let res = await QueryTarget(payload);
            return res;
        },

        UPDATE_SETTLEMENT_FORECAST: async ({ commit }, payload) => {
            let res = await UpdateSettlementForecast(payload);
            return res;
        },

        QUERY_PERSONAL: async ({ commit }, payload) => {
            let res = await QueryPersonal(payload);
            return res;
        },

        ASSGIN_PERSONAL: async ({ commit }, payload) => {
            let res = await AssginPersonal(payload);
            return res;
        },

        QUERY_PERSONAL2: async ({ commit }, payload) => {
            let res = await QueryPersonal2(payload);
            return res;
        },

        QUERY_MARK_TARGET: async ({ commit }, payload) => {
            let res = await QueryEditStockTarget(payload);
            return res;
        },

        QUERY_VIEW_TARGET: async ({ commit }, payload) => {
            let res = await QueryViewTarget(payload);
            return res;
        },

        // SAVE_STOCK_TARGET: async ({ commit }, payload) => {
        //     let res = await SaveStockTarget(payload);
        //     return res;
        // },

        QUERY_COMPANY_MARK_TARGET: async ({ commit }, payload) => {
            let res = await QueryCompanyMarkTarget(payload);
            return res;
        },

        // SAVE_COMPANY_MARK_TARGET: async ({ commit }, payload) => {
        //     let res = await SaveCompanyMarkTarget(payload);
        //     return res;
        // },

        // SAVE_TOTLA_MARK_TARGET: async ({ commit }, payload) => {
        //     let res = await SaveTotalMarkTarget(payload);
        //     return res;
        // },

        SAVE_ADJUST_RULE: async ({ commit }, payload) => {
            let res = await SaveAdjustRule(payload);
            return res;
        },

        SUBMIT_PREPARE: async ({ commit }, payload) => {
            let res = await SubmitPrepare(payload);
            return res;
        },

        QUERY_MANAGE_TARGET: async ({ commit }, payload) => {
            let res = await QueryManageTarget(payload);
            return res;
        },

        SAVE_MANAGE_TARGET: async ({ commit }, payload) => {
            let res = await SaveManageTarget(payload);
            return res;
        },

        SAVE_MARK_TARGET: async ({ commit }, payload) => {
            let res = await SaveMarkTarget(payload);
            return res;
        },

        QUERY_BASE_CUSTOMER: async ({ cvommit }, payload) => {
            let res = await QueryBaseCustomer(payload);
            return res;
        },

        VIEW_ITEMS_BY_CUSTOMER: async ({ commit }, payload) => {
            let res = await ViewItemsByCustomerId(payload);
            return res;
        },

        SAVE_ITEMS_TARGET: async ({ commit }, payload) => {
            let res = await SaveItemsTarget(payload);
            return res;
        },

        ADJUST_ITEMS_RULE: async ({ commit }, payload) => {
            let res = await AdjustItemsRule(payload);
            return res;
        },

        QUERY_UP_USER: async ({ commit }, payload) => {
            let res = await QueryUpUser(payload);
            return res;
        },

        QUERY_CUSTOMER_FINANCE: async ({ commit }, payload) => {
            let res = await QueryCustomerFinance(payload);
            return res;
        },

        QUERY_ITEMS_FINANCE: async ({ commit }, payload) => {
            let res = await QueryItemsFinance(payload);
            return res;
        },

        QUERY_SETTLEMENT_USER: async ({ commit }, payload) => {
            let res = await QuerySettlementUser(payload);
            return res;
        },

        QUERY_ITMES_SETTLEMENT: async ({ commit }, payload) => {
            let res = await QueryItemsSettlement(payload);
            return res;
        },

        QUERY_CUSTOMER_SETTLEMENT: async ({ commit }, payload) => {
            let res = await QueryCustomerSettlement(payload);
            return res;
        },

        // 新预估接口

        QUERY_FORECAST_BY_MONTH: async ({ commit }, payload) => {
            let res = await QueryForecastByMonth(payload);
            return res;
        },

        QUERY_VIEW_ITEMS_FORECAST: async ({ commit }, payload) => {
            let res = await QueryViewItemsForecast(payload);
            return res;
        },

        SUBMIT_FORECAST_NEW: async ({ commit }, payload) => {
            let res = await SubmitForecastNew(payload);
            return res;
        },

        QUERY_MEDICAL_ITEMS: async ({ commit }, payload) => {
            let res = await QueryMedicalItems(payload);
            if (res?.code == 200) {
                commit('SET_MEDICAL_ITEMS', res.data ?? []);
            }
            return res;
        },

        QUERY_TRACK_CUSTOMER: async ({ commit }, payload) => {
            let res = await QueryTrackCustomer(payload);
            return res;
        },

        QUERY_TRACK_MEDICAL: async ({ commit }, payload) => {
            let res = await QueryTrackMedical(payload);
            return res;
        },

        QUERY_MEDICAL_DOCTS: async ({ commit }, payload) => {
            let res = await QueryMedicalDocts(payload);
            return res;
        },

        QUERY_TREND: async ({ commit }, payload) => {
            let res = await QueryTrend(payload);
            return res;
        },

        // 联系人维度
        QUERY_SETTLE_BY_DOCTOR: async ({ commit }, payload) => {
            let res = await QuerySettleByDoctor(payload);
            if (res?.code == 200) {
                commit('SET_SETTLEMENT_DOCTOR', res.data ?? {});
            }
            return res;
        },

        QUERY_UP_DATA: async ({ commit }, payload) => {
            let res = await QueryUpData(payload);
            return res;
        },

        SAVE_UP_FORECAST: async ({ commit }, payload) => {
            let res = await SaveUpForecast(payload);
            return res;
        },

        // 未分配客户填写
        MARK_NO_ASSGIN_FORECAST: async ({ commit }, payload) => {
            let res = await MarkNoAssginForecast(payload);
            return res;
        },

        // 未分配客户
        QUERY_NO_ASSGIN_FORECAST: async ({ commit }, payload) => {
            let res = await QueryNoAssginForecast(payload);
            return res;
        },

        QUERY_INCOME_ACTUAL_FINISH_AREA: async ({}, payload) => {
            let res = await QueryIncomeActualFinishArea(payload);
            return res;
        },

        QUERY_INCOME_ACTUAL_FINISH_USER: async ({}, payload) => {
            let res = await QueryIncomeActualFinishUser(payload);
            return res;
        },
        QUERY_INCOME_ACTUAL_FINISH_CUSTOMER: async ({}, payload) => {
            let res = await QueryIncomeActualFinishCustomer(payload);
            return res;
        },

        // 收入偏差
        QUERY_OFFSET_AREA_DATA: async ({}, payload) => {
            let res = await QueryOffsetAreaData(payload);
            return res;
        },
        QUERY_OFFSET_USER_DATA: async ({}, payload) => {
            let res = await QueryOffsetUserData(payload);
            return res;
        },
        QUERY_OFFSET_CUSTOMER_DATA: async ({}, payload) => {
            let res = await QueryOffsetCustomerData(payload);
            return res;
        },

        // 同环比数据
        QUERY_INCOME_AREA_COMPARE: async ({}, payload) => {
            let res = await QueryIncomeAreaCompare(payload);
            return res;
        },

        QUERY_INCOME_USER_COMPARE: async ({}, payload) => {
            let res = await QueryIncomeUserCompare(payload);
            return res;
        },

        QUERY_INCOME_CUSTOMER_COMPARE: async ({}, payload) => {
            let res = await QueryIncomeCustomerCompare(payload);
            return res;
        }
    }
};
